<template>
  <div>
    <div class="top-line-wrap">
      <div class="menu-wrap clear-fix" @click="handleMenu">
        <i :class="['el-icon-menu',collapse==true?'menu-white':'menu-active']"></i>
      </div>
      <div class="system-name">
        <b>
          巢艺管理系统
        </b>
      </div>
      <div class="layout" @click="layout">
        退出登录
      </div>

    </div>
    <div :class="['slider-container-left',collapse==true?'slider-container-left-active':'']">
      <div class="loading-wrap" v-show="this.$store.state.menuLoading">
        <i class="el-icon-loading loading-i"></i>
      </div>
      <el-menu
        :router="true"
        :collapse="collapse"
        default-active="/"
        class="el-menu-vertical-menus"
        @open="handleOpen"
        @close="handleClose"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b">
        <template v-for="item in this.$store.state.menus">
          <template v-if="item.children">

            <el-submenu :index="item.resourceName">

              <template slot="title">
                <i class="el-icon-location"></i>
                <span>{{item.resourceName}}</span>
              </template>

              <template v-for="each in item.children">

                <template v-if="each.children">
                  <el-submenu :index="each.resourceName">
                    <template slot="title">
                      <i class="el-icon-location"></i>
                      <span>{{each.resourceName}}</span>
                    </template>

                    <template v-for="block in each.children">
                      <el-menu-item :index="block.menuUrl">
                        <i class="el-icon-document"></i>
                        <span slot="title">{{block.resourceName}}</span>
                      </el-menu-item>
                    </template>

                  </el-submenu>

                </template>
                <template v-else>
                  <el-menu-item :index="each.menuUrl">
                    <i class="el-icon-document"></i>
                    <span slot="title">{{each.resourceName}}</span>
                  </el-menu-item>

                </template>
              </template>

            </el-submenu>
          </template>
          <template v-else>
            <el-menu-item :index="item.menuUrl">
              <i class="el-icon-document"></i>
              <span slot="title">{{item.label}}</span>
            </el-menu-item>
          </template>
        </template>
      </el-menu>
    </div>
    <div :class="['slider-container-right',collapse==true?'slider-container-right-active':'']">
      <router-view/>

    </div>

  </div>
</template>
<script>
  import axios from 'axios'
  export default {
    name: 'MenuSlider',
    data() {
      return {
        collapse: false,
      }
    },
    mounted() {
      if(!window.isPc){
        this.collapse=true
      }
      this.$store.dispatch('getMenuList').then()
    },
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      handleMenu() {
        this.collapse = !this.collapse
      },
      async layout(){
       let r=await axios.get('/admin/layout')
        if(r.code==0){
         this.$message.success('退出成功')
          this.$router.push('/login')
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .menu-wrap {
    float left
    position: relative;
    height: 46px;
    width: 46px;
    display: inline-block;
    text-align: center;
    cursor: pointer
    i {
      font-size 24px;
      position absolute;
      left 50%;
      top 50%;
      transform translate(-50%, -50%)
    }
  }

  .top-line-wrap {
    background #3f474e;
    height 46px;
    width 100vw
  }

  .slider-container-left {
    width 240px;
    background rgb(84, 92, 100);
    height: calc(100vh - 46px)
    float left
    .el-menu {
      border-right: 0px solid white
    }
  }

  .slider-container-left-active {
    width 64px
  }

  .slider-container-right {
    float left
    padding 10px
    box-sizing border-box
    width calc(100% - 240px)
    height calc(100vh - 46px)
    overflow-y scroll
  }

  .slider-container-right-active {
    width calc(100vw - 64px)
  }

  .menu-active {
    color rgb(255, 208, 75)
  }

  .menu-white {
    color white
  }

  .system-name {
    float: left;
    height 46px;
    color white;
    line-height 46px;
    margin-left 10px
    b {
      font-weight: bolder;
      font-size 18px
    }
  }

  .layout {
    float: right;
    height 46px;
    line-height 46px;
    margin-right 20px
    color white
    cursor pointer
    padding auto 20px
  }

  .loading-wrap {
    text-align: center;
    padding: 20px 0px
    .loading-i {
      font-size: 30px
    }
  }
  .el-menu-vertical-menus{
    height: calc(100vh - 46px);
    overflow: scroll;
  }

</style>



// WEBPACK FOOTER //
// src/main/home/MenuSlider.vue